import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Food',
  icon: 'mdi-clipboard-outline ',
  path: '/reports/food/',
  children: [
    {
      path: '/reports/food/physicalInventory',
      name: 'Physical Inventory',
      meta: { id: 'reports-physicalInventory' },
      component: () => import('./physicalInventory.vue'),
      ...addPermissionsToRoute(['physicalInventory']),
      tags: ['Ending Inventory Cost'],
    },
    {
      path: '/reports/food/endingInventory',
      name: 'Ending Inventory',
      meta: { id: 'reports-endingInventory' },
      component: () => import('./endingInventory.vue'),
      ...addPermissionsToRoute(['physicalInventory']),
      tags: ['Ending Inventory Cost Summary'],
    },
    {
      path: '/reports/food/foodOverBase',
      name: 'Food Over Base',
      meta: { id: 'reports-fob' },
      component: () => import('./foodOverBase.vue'),
      ...addPermissionsToRoute(['fob']),
      tags: ['Controllable Food Cost Components', 'fob'],
    },
    {
      path: '/reports/food/inventoryStat',
      name: 'Inventory Stat',
      meta: { id: 'reports-inventoryStat' },
      component: () => import('./inventoryStat.vue'),
      ...addPermissionsToRoute(['inventoryStat']),
    },
    {
      path: '/reports/food/rawWastePromo',
      name: 'Raw Waste & Promo',
      meta: { id: 'reports-rawWastePromo' },
      component: () => import('./rawWaste/RawWastePromoWrapper.vue'),
      ...addPermissionsToRoute(['wastePromo']),
    },
    {
      path: '/reports/food/inventoryCount',
      name: 'Inventory Count',
      meta: { id: 'reports-inventoryCount' },
      component: () => import('./inventoryCount/inventoryCount.vue'),
      ...addPermissionsToRoute(['fob']),
    },
    {
      path: '/reports/food/rawItemCount',
      name: 'Raw Item Count',
      meta: { id: 'reports-rawItemCount' },
      component: () => import('./rawItemCount.vue'),
      ...addPermissionsToRoute(['fob']),
    },
  ],
};

export default routes;
